import { useCallback, useEffect, useState } from "react";
import client from "../client";
import handleApiError from "../../hooks/handleApiError";

export default function useFetchScorecardById(scorecardId) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const request = useCallback(async (id) => {
    try {
      setLoading(true);

      const res = await client.get(`/result/scorecard/${id}`);

      setData(res.data?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  useEffect(() => {
    if (scorecardId) request(scorecardId);
  }, [scorecardId, request]);

  return { data, loading };
}
